import axios from "axios";
import { toast } from "react-toastify";

const _pad = (num) => num.toString().padStart(2, "0");

export const addTranscription = async (
  appointmentId,
  providerData,
  providerId,
  userId
) => {
  const payload = {
    appointmentId,
    providerData,
    providerId,
    source: "provider",
    userId,
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/transcription/add-transcription`,
      payload
    );

    if (response.status === 200)
      console.log("🚀 -> response.data.message:", response.data.message);
  } catch (error) {
    console.error("🚀 -> addTranscription -> error:", error);
  }
};

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${_pad(minutes)}:${_pad(remainingSeconds)}`;
};

export const startTranscribing = async (
  channelName,
  setTranscriptionData,
  setTranscriptionOn,
  token,
  uid
) => {
  const payload = {
    channel_token: token,
    channel: channelName,
    uid: String(uid),
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/appointment/start-transcribing`,
      payload
    );

    if (response.status === 200) {
      const { builderToken, taskId } = response.data;

      // setTranscriptionOn(true);
      setTranscriptionData({ builderToken, taskId });
    }
  } catch (error) {
    console.error("🚀 -> startTranscribing -> error:", error);
  }
};

export const stopTranscribing = async (builderToken, taskId) => {
  if (!builderToken || !taskId) {
    return false;
    console.error("builderToken or taskId is missing");
    toast.error("builderToken or taskId is missing");
  }
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/appointment/stop-transcribing/${taskId}/${builderToken}`
    );

    if (response.status === 200) {
      console.log("Transcription deleted successfully!");

      return true;
    }

    return false;
  } catch (error) {
    console.error("🚀 -> stopTranscribing -> error:", error);

    return false;
  }
};

export const fetchAgoraToken = async (appointmentId, authToken) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/appointment/getOrGenerateToken/${appointmentId}`,
      { headers: { Authorization: `Bearer ${authToken}` } }
    );

    if (response.data.success) {
      return {
        data: response.data.data,
        success: true,
      };
    } else {
      return {
        error: response.data.message,
        success: false,
      };
    }
  } catch (error) {
    console.error("-> -> fetchAgoraToken -> error->", error);
    return {
      success: false,
      error: error.response?.data?.message ?? error.message,
    };
  }
};
